module.exports = __webpack_public_path__ + "static/media/heart.72110097.gif";